import { createSlice } from "@reduxjs/toolkit";
import { archiveNonRealLogHour, getNonRealLogHourList } from "./_nonRealLogHourAction";


interface NonRealLogHourState {
  nonRealLogHourList: any[];
  loading: boolean;
  error: string | null;
  totalCount: number;
}

const initialState: NonRealLogHourState = {
  nonRealLogHourList: [],
  loading: false,
  error: null,
  totalCount: 0,
};


export const nonRealLogHourReducer = createSlice({
  name: "nonRealLogHour",
  initialState: initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Log Hour List
      .addCase(getNonRealLogHourList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNonRealLogHourList.fulfilled, (state, action) => {
        state.loading = false;
        state.nonRealLogHourList = action.payload?.data;
        state.totalCount = action.payload?.count;
      })
      .addCase(getNonRealLogHourList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Archive Activity
      .addCase(archiveNonRealLogHour.fulfilled, (state, action) => {        
        state.nonRealLogHourList = state.nonRealLogHourList.filter((nonRealLogHour) => nonRealLogHour?.uuid !== action.payload?.data?.uuid);
      })
      .addCase(archiveNonRealLogHour.rejected, (state, action) => {
        state.error = action.payload as string;
      })
  },

});


export const { clearError } = nonRealLogHourReducer.actions;
export default nonRealLogHourReducer;